import { BUILD_CONFIG } from './config';

export const APP_VERSION = BUILD_CONFIG.version;
export const BUILD_TIME = new Date().toISOString();

// Git commit SHA
export const GIT_SHA = BUILD_CONFIG.gitSha;

export const getVersionString = () => {
  return `${APP_VERSION} (${GIT_SHA})`;
};

export const buildMeta = () => {
  return {
    version: APP_VERSION,
    git: GIT_SHA
  };
};
